import React from 'react'
import { Button, ListGroup, ListGroupItem, Card, CardHeader, CardBody } from 'reactstrap'
import { getName } from './TitlePrinter'
import '../styles/Location.css'

function divergentFacts(state) {
  let divOwner;
  if(!state.administrationIsOwner){
    divOwner = <li>Abweichender Auftraggeber: {getName(state.DeviantOwner)}</li>
  }
  let divInvoice;
  if(state.divergentInvoice){
    divInvoice = <li>Abweichender Rechnungsempfänger: {getName(state.InvoiceReceiver)}</li>
  }

  return (
    <div>
      {divOwner}
      {divInvoice}
    </div>
  );
}

export default props => (
    <ListGroup>
            {props.LocationRegistrations.map((registration, index) =>
                <ListGroupItem key={index}>
                  <Card id="card">
                    <CardHeader id="cardHeader">
                      Zählernummer {registration.metertype==='gas'? 'Erdgas' : 'Strom'}: {registration.meternumber}
                      <Button className="float-right" onClick={props.HandleRegistrationRemoval} id={registration.meternumber} ><i className="fa fa-close"></i></Button>
                    </CardHeader>
                    <CardBody>
                      <ul>
                        <li>Zählerstand: {registration.meterreading} </li>
                        <li>Lieferbeginn: {registration.deliveryStartDate.split("-").reverse().join(".")}</li>
                        <li>Referenz: {registration.refnumber}</li>
                        <li>Straße: {registration.street} {registration.housenumber} {registration.housenumberextension}</li>
                        <li>Ort: {registration.postcode} {registration.city}</li>
                        {divergentFacts(registration)}
                      </ul>
                    </CardBody>
                  </Card>
                </ListGroupItem>
            )}
    </ListGroup>
)


// WEBPACK FOOTER //
// ./src/components/RegisteredLocations.js